import React, { Component } from "react";
import ExercisesTrainingService from '../../../../../services/exercises/training/ExercisesTrainingService';
import { withTranslation } from "react-i18next";

type Props = {
  exerciseId: string;
  trainingId: number;
  onExerciseUpdate: () => void; // Funkcja do odświeżenia listy
  t: any;
};
type State = {};

class OptionsMove extends Component<Props, State> {
  handleMoveUp = async () => {
    const { exerciseId, trainingId, onExerciseUpdate } = this.props;
    try {
      await ExercisesTrainingService.updateExerciseOrderNumberUp(trainingId, exerciseId);
      onExerciseUpdate(); // Aktualizuj listę
    } catch (error) {
      console.error('Error moving exercise up:', error);
    }
  };

  handleMoveDown = async () => {
    const { exerciseId, trainingId, onExerciseUpdate } = this.props;
    try {
      await ExercisesTrainingService.updateExerciseOrderNumberDown(trainingId, exerciseId);
      onExerciseUpdate(); // Aktualizuj listę
    } catch (error) {
      console.error('Error moving exercise down:', error);
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <button onClick={this.handleMoveUp}>{t("buttons.move_up")}</button>
        &nbsp; &nbsp;
        <button onClick={this.handleMoveDown}>{t("buttons.move_down")}</button>
        {/* <p>{t("buttons.move_description")}<br/><br/></p> */}
        <br /><br />
      </div>
    );
  }
}

export default withTranslation("global")(OptionsMove);
